import React, { useEffect, useState } from "react";
import '../../assets/css/style.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import HeaderCourse from "./header-course";
import HeaderEmployee from "./header-employee";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useUser } from "../UserContext";
import HeaderResident from "./header-resident";
import HeaderFilterResident from "./header-filter-resident";

window.globalFilter = window.globalFilter || { value: "0" };

const Header = () => {
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const token = localStorage.getItem("token");
    const [isCollapsed, setIsCollapsed] = useState(false);
    const user = useUser();
    const location = useLocation();
    const [showInputBox, setShowInputBox] = useState(false);

    const DisplayHeaderEmployee =
        location.pathname === "/dashboard" ||
        location.pathname.includes("employee") ||
        location.pathname.includes("ahca-regulations") ||
        location.pathname.includes("task-type") ||
        location.pathname.includes("training-event");

    const DisplayHeaderResident =
        location.pathname === "/admission-log" ||
        location.pathname.includes("resident");

    const [searchFilter, setSearchFilter] = useState("0");
    const [searchTerm, setSearchTerm] = useState("");
    const [showHeaders, setShowHeaders] = useState(false);
    const [userMenuOpen, setUserMenuOpen] = useState(false);

    // 🔔 Notification states
    const [notifOpen, setNotifOpen] = useState(false);
    const [notifications, setNotifications] = useState([]);
    const [unreadCount, setUnreadCount] = useState(0);

    const toggleHeaders = () => setShowHeaders(!showHeaders);

    // 🔔 Fetch notifications from API
    useEffect(() => {
        const fetchNotifications = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/notifications/`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Token ${token}`,
                    },
                });

                if (!response.ok) return;

                const data = await response.json();
                setNotifications(data.notifications || []);
                setUnreadCount(data.unread_count || 0);
            } catch (error) {
                console.error("Failed to fetch notifications", error);
            }
        };

        if (token) fetchNotifications();
    }, [token]);

    // 🔔 Close dropdowns when clicking outside
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (!e.target.closest("#notif-wrapper")) setNotifOpen(false);
            if (!e.target.closest("#user-menu-wrapper")) setUserMenuOpen(false);
        };
        document.addEventListener("click", handleClickOutside);
        return () => document.removeEventListener("click", handleClickOutside);
    }, []);

    useEffect(() => {
        if (!token) {
            setError("No token found, redirecting to login...");
            navigate("/login");
            return;
        }
        const root = document.getElementById('root');
        if (root) {
            isCollapsed
                ? root.classList.add('nav-collapsed-min')
                : root.classList.remove('nav-collapsed-min');
        }
    }, [token, navigate, isCollapsed]);

    const toggleSidebar = (e) => {
        e.preventDefault();
        setIsCollapsed((prev) => !prev);
    };

    const handleFilterChange = (newValue) => {
        setSearchFilter(newValue);
        window.globalFilter.value = newValue;
        window.dispatchEvent(new CustomEvent('filterChanged', { detail: newValue }));
    };

    const renderHeader = (user) => (
        <div className="App">
            <section id="header" className="header-content-container animate-fade-up">
                <div className="header-section relative">

                    {/* Left: Menu + Facility Name */}
                    <div className="col-4 d-flex flex-lg-row align-items-center">
                        <div className="menu-button">
                            <a href="#/" onClick={toggleSidebar} className="toggle-min" id="step4">
                                <i className="fa fa-bars"></i>
                            </a>
                        </div>
                        <div>
                            <a href="/dashboard" className="logout-text">
                                <span
                                    className="newlogo-facilitname"
                                    data-tooltip={user.user?.facility?.name || "Facility Name"}
                                >
                                    {user.user?.facility?.name || "Facility Name"}
                                </span>
                            </a>
                        </div>
                    </div>

                    {/* Right: Nav + Notification + User Menu */}
                    <div className="col-8 pr-5">
                        <div className="flex justify-between items-center">

                            {/* Nav Left */}
                            <ul className="nav-left">
                                {DisplayHeaderResident && (
                                    <li className="searchDropdown">
                                        <HeaderFilterResident
                                            searchFilter={searchFilter}
                                            setSearchFilter={handleFilterChange}
                                            searchTerm={searchTerm}
                                            setSearchTerm={setSearchTerm}
                                            isResidentDashboard={false}
                                        />
                                    </li>
                                )}
                                {DisplayHeaderEmployee && (
                                    <li className="searchDropdown">
                                        <HeaderEmployee />
                                    </li>
                                )}
                                {DisplayHeaderEmployee && (
                                    <li className="searchDropdown">
                                        <HeaderCourse />
                                    </li>
                                )}
                                {DisplayHeaderResident && (
                                    <li className="searchDropdown">
                                        <HeaderResident />
                                    </li>
                                )}
                                {showHeaders && (
                                    <li className="showFilterResidence">
                                        {DisplayHeaderResident && (
                                            <HeaderFilterResident
                                                searchFilter={searchFilter}
                                                setSearchFilter={handleFilterChange}
                                                searchTerm={searchTerm}
                                                setSearchTerm={setSearchTerm}
                                                isResidentDashboard={false}
                                            />
                                        )}
                                    </li>
                                )}
                                {DisplayHeaderResident && (
                                    <li>
                                        <a href="#" className="faq" onClick={toggleHeaders}>
                                            <strong>
                                                <i className="fa-solid fa-filter"></i>
                                            </strong>
                                        </a>
                                    </li>
                                )}
                            </ul>

                            {/* Right Icons: FAQ + Bell + User */}
                            <div className="flex justify-center items-center gap-3">

                                {/* FAQ */}
                                <a
                                    href="https://alfboss.com/faq/"
                                    className="faq"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <strong>
                                        <i className="fa-solid fa-circle-question hover:text-white"></i>
                                    </strong>
                                </a>

                                {/* 🔔 Notification Bell */}
                                <div id="notif-wrapper" style={{ position: "relative" }}>
                                    <button
                                        onClick={() => setNotifOpen(!notifOpen)}
                                        style={{
                                            background: "none",
                                            border: "none",
                                            cursor: "pointer",
                                            position: "relative",
                                            padding: "8px",
                                        }}
                                    >
                                        <i
                                            className="fa-solid fa-bell"
                                            style={{ fontSize: "20px", color: "white" }}
                                        ></i>
                                        {unreadCount > 0 && (
                                            <span
                                                style={{
                                                    position: "absolute",
                                                    top: "2px",
                                                    right: "2px",
                                                    background: "red",
                                                    color: "white",
                                                    borderRadius: "50%",
                                                    fontSize: "10px",
                                                    width: "18px",
                                                    height: "18px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    fontWeight: "bold",
                                                }}
                                            >
                                                {unreadCount}
                                            </span>
                                        )}
                                    </button>

                                    {/* Notification Dropdown */}
                                    {notifOpen && (
                                        <div
                                            style={{
                                                position: "absolute",
                                                right: 0,
                                                top: "45px",
                                                width: "340px",
                                                background: "white",
                                                borderRadius: "10px",
                                                boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
                                                zIndex: 9999,
                                                border: "1px solid #e5e7eb",
                                            }}
                                        >
                                            {/* Dropdown Header */}
                                            <div
                                                style={{
                                                    padding: "12px 16px",
                                                    borderBottom: "1px solid #e5e7eb",
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                }}
                                            >
                                                <span style={{ fontWeight: "600", fontSize: "15px", color: "#111" }}>
                                                    Notifications
                                                </span>
                                                <span
                                                    style={{
                                                        fontSize: "12px",
                                                        background: "#fef2f2",
                                                        color: "#dc2626",
                                                        padding: "2px 8px",
                                                        borderRadius: "20px",
                                                        fontWeight: "500",
                                                    }}
                                                >
                                                    {unreadCount} Unread
                                                </span>
                                            </div>

                                            {/* Notification Items */}
                                            <div style={{ maxHeight: "320px", overflowY: "auto" }}>
                                                {notifications.length === 0 ? (
                                                    <div
                                                        style={{
                                                            padding: "20px",
                                                            textAlign: "center",
                                                            color: "#9ca3af",
                                                        }}
                                                    >
                                                        No notifications
                                                    </div>
                                                ) : (
                                                    notifications.map((notif) => (
                                                        <div
                                                            key={notif.id}
                                                            onClick={async () => {
                                                                if (!notif.is_read) {
                                                                    try {
                                                                        await fetch(
                                                                            `${process.env.REACT_APP_API_BASE_URL}/notifications/${notif.id}/mark-read/`,
                                                                            {
                                                                                method: "POST",
                                                                                headers: {
                                                                                    "Content-Type": "application/json",
                                                                                    Authorization: `Token ${token}`,
                                                                                },
                                                                            }
                                                                        );
                                                                        setNotifications((prev) =>
                                                                            prev.map((n) =>
                                                                                n.id === notif.id
                                                                                    ? { ...n, is_read: true }
                                                                                    : n
                                                                            )
                                                                        );
                                                                        setUnreadCount((prev) => Math.max(0, prev - 1));
                                                                    } catch (err) {
                                                                        console.error("Failed to mark as read", err);
                                                                    }
                                                                }
                                                                navigate("/notifications");
                                                                setNotifOpen(false);
                                                            }}
                                                            style={{
                                                                padding: "12px 16px",
                                                                borderBottom: "1px solid #f3f4f6",
                                                                background: notif.is_read ? "#f9fafb" : "#ffffff",
                                                                display: "flex",
                                                                justifyContent: "space-between",
                                                                alignItems: "flex-start",
                                                                gap: "10px",
                                                                cursor: "pointer",
                                                                opacity: notif.is_read ? 0.6 : 1,
                                                                transition: "opacity 0.2s",
                                                            }}
                                                        >
                                                            <div style={{ flex: 1 }}>
                                                                <div
                                                                    style={{
                                                                        fontWeight: "600",
                                                                        fontSize: "13px",
                                                                        color: notif.is_read ? "#6b7280" : "#111",
                                                                        marginBottom: "3px",
                                                                    }}
                                                                >
                                                                    {notif.title}
                                                                </div>
                                                                <div style={{ fontSize: "12px", color: "#6b7280" }}>
                                                                    {notif.description}
                                                                </div>
                                                                <div
                                                                    style={{
                                                                        fontSize: "11px",
                                                                        color: "#9ca3af",
                                                                        marginTop: "4px",
                                                                    }}
                                                                >
                                                                    {notif.employee?.first_name} {notif.employee?.last_name} · {notif.created_at}
                                                                </div>
                                                            </div>
                                                            {/* ✅ Green = Read, Red = Unread */}
                                                            <span
                                                                style={{
                                                                    fontSize: "11px",
                                                                    fontWeight: "600",
                                                                    color: notif.is_read ? "#16a34a" : "#dc2626",
                                                                    background: notif.is_read ? "#f0fdf4" : "#fef2f2",
                                                                    padding: "2px 8px",
                                                                    borderRadius: "20px",
                                                                    whiteSpace: "nowrap",
                                                                }}
                                                            >
                                                                {notif.is_read ? "Read" : "Unread"}
                                                            </span>
                                                        </div>
                                                    ))
                                                )}
                                            </div>

                                            {/* View All Link */}
                                            <div
                                                style={{
                                                    padding: "10px 16px",
                                                    borderTop: "1px solid #e5e7eb",
                                                    textAlign: "center",
                                                }}
                                            >
                                                <button
                                                    onClick={() => {
                                                        navigate("/notifications");
                                                        setNotifOpen(false);
                                                    }}
                                                    style={{
                                                        background: "none",
                                                        border: "none",
                                                        color: "#16a34a",
                                                        fontWeight: "600",
                                                        fontSize: "13px",
                                                        cursor: "pointer",
                                                    }}
                                                >
                                                    View All Notifications →
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                </div>

                                {/* User Menu */}
                                <div id="user-menu-wrapper" className="relative">
                                    <button
                                        onClick={() => setUserMenuOpen(!userMenuOpen)}
                                        className="flex items-center space-x-3 px-4 py-4 rounded-lg hover:bg-white/30 hover:backdrop-blur-sm transition"
                                    >
                                        <div className="w-10 h-10 bg-gradient-to-br from-emerald-500 to-teal-500 rounded-full flex items-center justify-center">
                                            <span className="text-white text-xl font-semibold">
                                                {(
                                                    user?.user?.user?.first_name
                                                        ? user.user?.user?.first_name
                                                        : user.user?.user?.username || " "
                                                )
                                                    ?.charAt(0)
                                                    ?.toUpperCase()}
                                            </span>
                                        </div>
                                        <div className="md:block text-left">
                                            <div className="text-3xl text-white font-medium text-slate-900">
                                                {user.user?.user?.first_name || " "}
                                            </div>
                                        </div>
                                        <i className="fas fa-chevron-down"></i>
                                    </button>

                                    {userMenuOpen && (
                                        <div className="absolute right-0 mt-2 w-56 bg-white rounded-lg shadow-lg border border-slate-200 py-1 z-50">
                                            <hr className="my-1" />
                                            <Link to={"/logout"} className="hover:!no-underline">
                                                <button className="w-full flex items-center space-x-3 px-4 py-2 text-sm text-red-600 hover:bg-red-50 no-underline hover:!no-underline">
                                                    <p className="text-2xl m-0 !no-underline hover:!no-underline">
                                                        <i className="fas fa-sign-out-alt"></i>
                                                        <span className="ml-2 !no-underline hover:!no-underline">
                                                            Logout
                                                        </span>
                                                    </p>
                                                </button>
                                            </Link>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );

    if (error) return renderHeader();
    return renderHeader(user);
};

export default Header;